import Phaser from "phaser";

export class PlayerInput {
    private readonly cursors: Phaser.Types.Input.Keyboard.CursorKeys;
    private readonly wasd: {
        up: Phaser.Input.Keyboard.Key;
        down: Phaser.Input.Keyboard.Key;
        left: Phaser.Input.Keyboard.Key;
        right: Phaser.Input.Keyboard.Key;
    };
    private readonly getVirtualDirection?: () => Phaser.Math.Vector2;

    constructor(scene: Phaser.Scene, getVirtualDirection?: () => Phaser.Math.Vector2) {
        this.cursors = scene.input.keyboard?.createCursorKeys() as Phaser.Types.Input.Keyboard.CursorKeys;
        this.wasd = scene.input.keyboard?.addKeys("W,S,A,D") as {
            up: Phaser.Input.Keyboard.Key;
            down: Phaser.Input.Keyboard.Key;
            left: Phaser.Input.Keyboard.Key;
            right: Phaser.Input.Keyboard.Key;
        };
        this.getVirtualDirection = getVirtualDirection;
    }

    getDirection(): Phaser.Math.Vector2 {
        const virtualDirection = this.getVirtualDirection?.() ?? new Phaser.Math.Vector2(0, 0);
        const x = (this.cursors.right?.isDown || this.wasd.right?.isDown ? 1 : 0) - (this.cursors.left?.isDown || this.wasd.left?.isDown ? 1 : 0) + virtualDirection.x;
        const y = (this.cursors.down?.isDown || this.wasd.down?.isDown ? 1 : 0) - (this.cursors.up?.isDown || this.wasd.up?.isDown ? 1 : 0) + virtualDirection.y;
        return new Phaser.Math.Vector2(x, y).normalize();
    }
}
